import React from 'react';
import { Typography } from '@mui/material';

function CheckoutSuccess() {
  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        {/* Thank you for your order. */}
        ส่งข้อมูลสำเร็จ
      </Typography>
      <Typography variant="subtitle1">
        ระบบดำเนินการส่งข้อมูลให้เจ้าหน้าที่ฝ่ายทรัพยากรบุคคลเรียบร้อยแล้ว
        {/* Your order number is #2001539. We have emailed your order confirmation,
        and will send you an update when your order has shipped. */}
      </Typography>
    </React.Fragment>
  );
}

export default CheckoutSuccess;
